function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { withRouter } from 'react-router';
import PubSub from 'pubsub-js';
import { Input } from '@progress/kendo-react-inputs';
import SearchService from './service';
import { getRecent, addRecent } from './recent';
import { bestResult } from './rank';
class SearchBar extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onChange", event => {
      const term = event.target.value || '';
      this.setState({
        term,
        show: true,
        selectedIndex: -1
      });
      if (!term.trim()) {
        this.setState({
          loading: false,
          groups: {},
          ranked: [],
          classification: null,
          recent: getRecent()
        });
        this.service.cancel();
        return;
      }
      this.setState({
        loading: true
      });
      this.service.search(term, {
        currentPath: this.props.location.pathname
      }).then(result => {
        if (this.state.term !== term) return;
        this.setState({
          loading: false,
          groups: result.groups || {},
          ranked: result.ranked || [],
          classification: result.classification,
          locationConfirmed: !!result.locationConfirmed
        });
      });
    });
    _defineProperty(this, "onFocus", () => {
      this.setState({
        show: true,
        recent: getRecent()
      });
    });
    _defineProperty(this, "onBlur", () => {
      setTimeout(() => this.setState({
        show: false
      }), 150);
    });
    _defineProperty(this, "onKeyDown", event => {
      const items = this._flatItems();
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.setState({
          selectedIndex: Math.min(this.state.selectedIndex + 1, items.length - 1)
        });
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        this.setState({
          selectedIndex: Math.max(this.state.selectedIndex - 1, -1)
        });
      } else if (event.key === 'Enter') {
        event.preventDefault();
        const idx = this.state.selectedIndex;
        if (idx >= 0 && items[idx]) {
          this._selectItem(items[idx]);
        } else if (this.state.term.trim()) {
          this._fallbackNavigate();
        }
      } else if (event.key === 'Escape') {
        this.setState({
          show: false
        });
      }
    });
    this.service = new SearchService();
    this.anchor = /*#__PURE__*/React.createRef();
    this.state = {
      term: '',
      show: false,
      loading: false,
      groups: {},
      ranked: [],
      classification: null,
      selectedIndex: -1,
      recent: getRecent()
    };
  }
  componentWillUnmount() {
    this.service.cancel();
  }
  // Everything selectable, in the order it renders: the MI action, the
  // results (rank.js returns them grouped in display order), then "See all".
  _flatItems() {
    const items = [];
    const {
      term,
      classification
    } = this.state;
    if (this._miLocationItem()) items.push({
      type: 'mi_action',
      term
    });
    for (const r of this.state.ranked) {
      items.push({
        type: 'result',
        result: r
      });
    }
    if (term.trim() && classification && classification.entities.length) {
      items.push({
        type: 'fallback',
        term
      });
    }
    return items;
  }
  _miLocationItem() {
    const {
      term,
      classification,
      locationConfirmed
    } = this.state;
    if (!term.trim() || !classification) return null;
    const isLocationShape = classification.hard && classification.entities[0] === 'locations';
    const isLocation = isLocationShape || locationConfirmed;
    if (!isLocation) return null;
    const onMI = (this.props.location.pathname || '').startsWith('/MarketIntelligence');
    if (onMI) {
      return {
        label: `Set dashboard location: ${term}`,
        term
      };
    }
    return {
      label: `View in Market Intelligence → ${term}`,
      term,
      navigate: true
    };
  }
  _selectItem(item) {
    const ctx = this.state.classification && this.state.classification.context || {};
    if (item.type === 'result') {
      const {
        result
      } = item;
      addRecent(this.state.term);
      this._hide();
      this.props.history.push(result.config.detailLink(result.row, ctx));
    } else if (item.type === 'fallback') {
      addRecent(this.state.term);
      this._hide();
      this.props.history.push(`/Search/${encodeURIComponent(this.state.term.trim())}`);
    } else if (item.type === 'mi_action') {
      const miItem = this._miLocationItem();
      if (!miItem) return;
      addRecent(this.state.term);
      this._hide();
      if (miItem.navigate) {
        this.props.history.push(`/MarketIntelligence?location=${encodeURIComponent(miItem.term)}`);
      } else {
        PubSub.publish('mi-set-location', {
          value: miItem.term
        });
      }
    }
  }

  // Enter with nothing selected: the list page of the best match's source
  // (only sources that actually matched — gated ones never get here), else
  // the full results page.
  _fallbackNavigate() {
    const {
      term,
      ranked,
      classification
    } = this.state;
    const ctx = classification && classification.context || {};
    addRecent(term);
    this._hide();
    const best = bestResult(ranked);
    if (best && best.config.listLink) {
      this.props.history.push(best.config.listLink(term, ctx));
      return;
    }
    this.props.history.push(`/Search/${encodeURIComponent(term.trim())}`);
  }
  _hide() {
    this.setState({
      show: false,
      term: '',
      ranked: [],
      groups: {},
      selectedIndex: -1
    });
  }
  _selectRecent(term) {
    this.setState({
      term
    }, () => this.onChange({
      target: {
        value: term
      }
    }));
  }
  _renderRow(item, flatIdx) {
    const selected = this.state.selectedIndex === flatIdx;
    const cls = 'plk-search-row' + (selected ? ' selected' : '');
    if (item.type === 'result') {
      const {
        result
      } = item;
      const name = result.config.displayName(result.row) || '';
      const sub = result.config.displaySub(result.row) || '';
      return /*#__PURE__*/React.createElement("div", {
        key: `r-${flatIdx}`,
        className: cls,
        onMouseDown: e => {
          e.preventDefault();
          this._selectItem(item);
        },
        onMouseEnter: () => this.setState({
          selectedIndex: flatIdx
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: "plk-search-row-name"
      }, name), sub && /*#__PURE__*/React.createElement("div", {
        className: "plk-search-row-sub"
      }, sub));
    }
    if (item.type === 'fallback') {
      return /*#__PURE__*/React.createElement("div", {
        key: `f-${flatIdx}`,
        className: cls + ' plk-search-fallback',
        onMouseDown: e => {
          e.preventDefault();
          this._selectItem(item);
        },
        onMouseEnter: () => this.setState({
          selectedIndex: flatIdx
        })
      }, "See all results for \"", item.term, "\"");
    }
    if (item.type === 'mi_action') {
      const miItem = this._miLocationItem();
      return /*#__PURE__*/React.createElement("div", {
        key: `mi-${flatIdx}`,
        className: cls + ' plk-search-mi',
        onMouseDown: e => {
          e.preventDefault();
          this._selectItem(item);
        },
        onMouseEnter: () => this.setState({
          selectedIndex: flatIdx
        })
      }, /*#__PURE__*/React.createElement("span", {
        className: "material-icons plk-search-mi-icon"
      }, "leaderboard"), /*#__PURE__*/React.createElement("span", null, miItem && miItem.label));
    }
    return null;
  }

  // Walks the flat list so what you see is exactly what the arrow keys
  // travel: a label row whenever the source changes.
  _renderItems(items) {
    const counts = {};
    this.state.ranked.forEach(r => {
      counts[r.entityKey] = (counts[r.entityKey] || 0) + 1;
    });
    const blocks = [];
    let lastKey = null;
    items.forEach((item, idx) => {
      if (item.type === 'result' && item.result.entityKey !== lastKey) {
        lastKey = item.result.entityKey;
        blocks.push(/*#__PURE__*/React.createElement("div", {
          key: `g-${lastKey}`,
          className: "plk-search-group-label"
        }, item.result.label, " \xB7 ", counts[lastKey]));
      }
      blocks.push(this._renderRow(item, idx));
    });
    return blocks;
  }
  render() {
    const {
      term,
      show,
      loading,
      ranked,
      recent,
      classification
    } = this.state;
    const items = this._flatItems();
    const showRecent = show && !term.trim() && recent.length > 0;
    const showNoResults = show && term.trim() && !loading && ranked.length === 0 && classification && !classification.entities.length;
    const showPopup = show && (showRecent || term.trim().length > 0);
    return /*#__PURE__*/React.createElement("div", {
      className: "plk-search-bar",
      ref: this.anchor
    }, /*#__PURE__*/React.createElement(Input, {
      placeholder: "SEARCH",
      value: term,
      onChange: this.onChange,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onKeyDown: this.onKeyDown,
      autoComplete: "off"
    }), showPopup && /*#__PURE__*/React.createElement("div", {
      className: "plk-search-dropdown"
    }, showRecent && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: "plk-search-group-label"
    }, "Recent"), recent.map((r, i) => /*#__PURE__*/React.createElement("div", {
      key: `rc-${i}`,
      className: "plk-search-row",
      onMouseDown: e => {
        e.preventDefault();
        this._selectRecent(r.term);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons plk-search-row-icon"
    }, "history"), /*#__PURE__*/React.createElement("span", null, r.term)))), !showRecent && loading && /*#__PURE__*/React.createElement("div", {
      className: "plk-search-status"
    }, "Searching\u2026"), !showRecent && !loading && ranked.length === 0 && term.trim() && classification && classification.entities.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "plk-search-status"
    }, "No matches"), !showRecent && !loading && this._renderItems(items), showNoResults && /*#__PURE__*/React.createElement("div", {
      className: "plk-search-status"
    }, "Type to search")));
  }
}
export default withRouter(SearchBar);